<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
  <div *ngFor="let option of stepData?.options" class="survey-option" [class.selected]="selectedOptionId === option._id">
    <button type="button" (click)="onSelectOption(option)" [class.selected]="selectedOptionId === option._id">
      {{ getLangValue(option.text) }}
    </button>
  </div>
  <div *ngIf="!isValid() && selectedOptionId !== null" class="error">
    Please select an option
  </div>
</div>
